import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from 'vue';

interface Props {
  // ダイアログ表示フラグ
  isDispDialog: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'PrivacyPolicyDialog',
  props: {
    isDispDialog: { type: Boolean }
  },
  emits: ['closeDialog'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// ダイアログ表示フラグ
const isDispDialog = ref(computed(() => props.isDispDialog));

// スクロールフラグ
const isBottomScroll = ref(true);

/**
 * OKボタンを活性に設定
 * @param verticalPercentage スクロール位置
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const setEnableButton = ({ verticalPercentage }: any) => {
  // スクロール位置が最下部の場合
  if (verticalPercentage >= 0.8) {
    isBottomScroll.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: isDispDialog.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isDispDialog).value = $event)),
    persistent: "",
    class: "privacy-policy-area"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { style: {"width":"80%","max-width":"900px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "privacy-policy-title q-pb-none" }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("プライバシーポリシー ")
            ])),
            _: 1
          }),
          _createVNode(_component_q_separator, {
            inset: "",
            spaced: ""
          }),
          _createVNode(_component_q_scroll_area, {
            style: {"height":"500px","width":"90%","margin":"0 auto","padding-right":"15px"},
            visible: "",
            onScroll: setEnableButton
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("div", { class: "privacy-policy-item" }, "1.個人情報とは", -1),
              _createElementVNode("p", null, " 個人情報とは、個人情報の保護に関する法律に規定される生存する個人に関する情報、ならびに特定の個人情報と容易に照合することができ、それにより特定の個人を識別することができる情報をいいます。 ", -1),
              _createElementVNode("div", { class: "privacy-policy-item" }, "2.個人情報の取得について", -1),
              _createElementVNode("p", null, " 弊社は、あらかじめご本人へ収集目的を明確にした上で適正に個人情報を取得し、偽りその他不正の手段により取得することはありません。 ", -1),
              _createElementVNode("div", { class: "privacy-policy-item" }, "3.クッキー・IPアドレス情報", -1),
              _createElementVNode("p", null, " クッキー及びIPアドレス情報については、それら単独では特定の個人を識別することができないため、個人情報とは考えておりません。ただしこれら情報と個人情報が一体となって使用される場合にはこれら情報も個人情報とみなします。また、クッキー情報については、ブラウザの設定で拒否することが可能です。クッキーを拒否するとサービスが受けられない場合は、その旨の公表に努めます。 ", -1),
              _createElementVNode("div", { class: "privacy-policy-item" }, "4.個人情報の利用について", -1),
              _createElementVNode("p", null, [
                _createTextVNode(" 弊社は、あらかじめご本人の同意を得ず、利用目的の達成に必要な範囲を超えて個人情報を取扱うことはありません。"),
                _createElementVNode("br"),
                _createTextVNode(" ただし、以下の場合はこの限りではありません。 ")
              ], -1),
              _createElementVNode("ol", null, [
                _createElementVNode("li", null, "法令に基づく場合"),
                _createElementVNode("li", null, [
                  _createTextVNode(" 人の生命、身体または財産の保護のために必要がある場合であって、ご本人の同意を得ることが困難であるとき"),
                  _createElementVNode("br")
                ]),
                _createElementVNode("li", null, [
                  _createTextVNode(" 公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、ご本人の同意を得ることが困難であるとき"),
                  _createElementVNode("br")
                ]),
                _createElementVNode("li", null, " 国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ご本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき ")
              ], -1),
              _createElementVNode("div", { class: "privacy-policy-item" }, "5.個人情報の管理と保護、セキュリティについて", -1),
              _createElementVNode("p", null, " 弊社は個人情報へのアクセス管理、外部からの不正なアクセスの防止、その他の個人情報の安全管理のために必要かつ適切な処置を厳重に行うこととし、個人情報の漏洩、紛失、破壊、改ざん及び不正アクセスなどの予防・是正に努めます。 ", -1),
              _createElementVNode("div", { class: "privacy-policy-item" }, "6.個人情報の開示について", -1),
              _createElementVNode("p", null, [
                _createTextVNode(" 弊社は、お客様本人またはその代理人から、当該個人情報の開示についての請求があったときは、次の各号の場合を除き、適切な期間でご回答いたします。"),
                _createElementVNode("br")
              ], -1),
              _createElementVNode("ol", null, [
                _createElementVNode("li", null, "ご本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合"),
                _createElementVNode("li", null, "弊社の業務の適正な実施に著しい支障を及ぼすおそれがある場合"),
                _createElementVNode("li", null, "法令に違反することとなる場合")
              ], -1),
              _createElementVNode("div", { class: "privacy-policy-item" }, "7.個人情報の訂正等について", -1),
              _createElementVNode("p", null, " 弊社は、ご本人またはその代理人から当該個人情報が真実でないという理由によって、内容の訂正、追加または削除(以下「訂正等」といいます)の申出があった場合、他の法令の規定により特別の手続きが定められている場合を除き、合理的な期間で調査を行い、その結果に基き利用目的の達成に必要な範囲内において当該個人情報の内容の訂正等を行い、その旨をご本人に通知します。 ", -1),
              _createElementVNode("div", { class: "privacy-policy-item" }, "8.個人情報のお問合せ", -1),
              _createElementVNode("p", null, "弊社のプライバシーポリシーに関するお問合せは、お問合せフォームからお願いいたします。", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_q_card_actions, {
            align: "center",
            class: "q-mt-sm q-mb-md"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                color: "primary",
                label: "OK",
                disable: isBottomScroll.value,
                style: {"width":"220px"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('closeDialog', true)))
              }, null, 8, ["disable"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})